import React, { useState } from 'react'
import PageBanner from '../Components/PageBanner'
import ServicesOne from '../Components/Services/ServicesOne'
import ServicesCta from '../Components/Services/ServicesCta'
import BestFeatures from '../Components/Features/BestFeatures'
import Pricing from '../Components/Price/Pricing'
import FaqOne from '../Components/Faq/FaqOne'
import bannerBg from '../assets/img/Banners/Memberships.jpg';
import MembershipsData from '../Components/Team/MembershipsData'

const Memberships = () => {
      const [selectedImage, setSelectedImage] = useState(null);
      const [zoom, setZoom] = useState(1); // Default zoom level
    
      // Reset zoom when closing modal
      const closeModal = () => {
        setSelectedImage(null);
        setZoom(1);
      };
    
      // Handle zoom with scroll
      const handleWheelZoom = (e) => {
        if (e.deltaY < 0) {
          setZoom((prevZoom) => Math.min(prevZoom + 0.2, 3)); // Max zoom 3x
        } else {
          setZoom((prevZoom) => Math.max(prevZoom - 0.2, 1)); // Min zoom 1x
        }
      };
  return (
    <>
       <PageBanner title="Memberships    " bannerBg={bannerBg} currentPage="Memberships " />
       <section className="our-team-wrapper section-padding pb-0">
        <div className="container">
          <div className="row">
            <div className="col-xl-6 offset-xl-3 col-lg-8 offset-lg-2 text-center col-12">
              <div className="block-contents">
                <div className="section-title">
                  <h2>Certificates</h2>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            {MembershipsData.map((data) => (
              <div className="col-md-6 col-xl-4 col-12" key={data.id}>
                <div className="single-team-member">
                  <div className="team-img" style={{ height: '100%' }}>
                    <img
                      src={data.img}
                      alt="Certificate"
                      style={{ cursor: 'pointer' }}
                      onClick={() => setSelectedImage(data.img)}
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Image Preview Modal with Zoom & Close Button */}
      {selectedImage && (
        <div
          className="image-preview-modal"
          onClick={closeModal}
          onWheel={handleWheelZoom} // Zoom on scroll
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgba(0,0,0,0.8)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1000,
          }}
        >
          {/* Close Button */}
          <button
            onClick={closeModal}
            style={{
              position: 'absolute',
              top: '20px',
              right: '30px',
              fontSize: '30px',
              color: '#fff',
              background: 'transparent',
              border: 'none',
              cursor: 'pointer',
            }}
          >
            ✖
          </button>

          {/* Zoomable Image */}
          <img
            src={selectedImage}
            alt="Preview"
            style={{ maxWidth: '90%', maxHeight: '90%', borderRadius: '8px' }}
          />
        </div>
      )}
    </>
  )
}

export default Memberships
